// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { CATALOG_PRODUCTS_RETURNABLE_ACCESSORIES_URL } from './product.constants';
import { ProductReturnableAccessoryDetails } from './product.interfaces';

/**
 * Get returnable accessories api
 */
export const getProductsReturnableAccessories = (
  productsIds: number[]
): Promise<AxiosResponse<ProductReturnableAccessoryDetails[]>> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_PRODUCTS_RETURNABLE_ACCESSORIES_URL}?productsIds=${productsIds}`;

  return axios.get(url);
};
